export enum EAC_ENTITLEMENT_STATE {
  PENDING_REVIEW = 'PENDING_REVIEW',
  PLANNED = 'PLANNED',
  LOCKED = 'LOCKED',
  PURCHASING = 'PURCHASING',
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
  ORDER_REQUIRED = 'ORDER_REQUIRED',
  FULFILLED = 'FULFILLED',
}

export enum ORDER_ATTEMPT_STATUS {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export enum ORDER_STATE {
  ORDER_CREATED = 'ORDER_CREATED',
  PENDING_FULFILLMENT = 'PENDING_FULFILLMENT',
  PENDING_RETIREMENT = 'PENDING_RETIREMENT',
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  CANCELLED = 'CANCELLED',
  FULFILLED = 'FULFILLED',
}
